import { render, staticRenderFns } from "./ZhanhuiDetails.vue?vue&type=template&id=3c49ca68&scoped=true"
import script from "./ZhanhuiDetails.vue?vue&type=script&lang=js"
export * from "./ZhanhuiDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c49ca68",
  null
  
)

export default component.exports